{{#if isPipelinedWrite}}
virtual function int get_next_response_priority_upper_bound();
  {{ responsePriorityUpperBoundVariable.identifier }} = {{ responsePriorityUpperBoundVariable.identifier }} - 1;
  return {{ responsePriorityUpperBoundVariable.identifier }};
endfunction
{{/if}}
